import {
    CREATE_SIZE_RATIO_REQUEST,
    CREATE_SIZE_RATIO_SUCCESS,
    CREATE_SIZE_RATIO_FAILURE,
    DELETE_SIZE_RATIO_REQUEST,
    DELETE_SIZE_RATIO_SUCCESS,
    DELETE_SIZE_RATIO_FAILURE,
    FETCH_SINGLE_SIZE_RATIO_REQUEST,
    FETCH_SINGLE_SIZE_RATIO_SUCCESS,
    FETCH_SINGLE_SIZE_RATIO_FAILURE,
    FETCH_SIZE_RATIO_REQUEST,
    FETCH_SIZE_RATIO_SUCCESS,
    FETCH_SIZE_RATIO_FAILURE,
    UPDATE_SIZE_RATIO_REQUEST,
    UPDATE_SIZE_RATIO_SUCCESS,
    UPDATE_SIZE_RATIO_FAILURE,
    RESET_SIZE_RATIO_INFO,
    CREATE_SIZE_RATIO_FORM,
    UPDATE_SIZE_RATIO_FORM,
    RESET_SIZE_RATIO_DATA
} from './sizeRatio.actionsType';

export const SIZE_RATIO = 'sizeRatio';

let initialState = {
    loading: false,
    sizeRatio: [],
    sizeRatioform: {
        fldQuatity01: '',
        fldQuatity02: '',
        fldQuatity03: '',
        fldQuatity04: '',
        fldQuatity05: '',
        fldQuatity06: '',
        fldQuatity07: '',
        fldQuatity08: '',
        fldQuatity09: '',
        fldQuatity10: '',
        fldQuatity11: '',
        fldQuatity12: '',
        fldQuatity13: '',
        fldQuatity14: '',
        fldQuatity15: '',
        fldQuatity16: '',
        fldQuatity17: '',
        fldQuatity18: ''
    },
    selectedState: {},
    errorMessage: ''
};

export let sizeRatioReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SIZE_RATIO_REQUEST:
        case CREATE_SIZE_RATIO_REQUEST:
        case UPDATE_SIZE_RATIO_REQUEST:
        case FETCH_SINGLE_SIZE_RATIO_REQUEST:
        case DELETE_SIZE_RATIO_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SIZE_RATIO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeRatio: updatePayload
            };
        case CREATE_SIZE_RATIO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeRatioform: {
                    fldQuatity01: '',
                    fldQuatity02: '',
                    fldQuatity03: '',
                    fldQuatity04: '',
                    fldQuatity05: '',
                    fldQuatity06: '',
                    fldQuatity07: '',
                    fldQuatity08: '',
                    fldQuatity09: '',
                    fldQuatity10: '',
                    fldQuatity11: '',
                    fldQuatity12: '',
                    fldQuatity13: '',
                    fldQuatity14: '',
                    fldQuatity15: '',
                    fldQuatity16: '',
                    fldQuatity17: '',
                    fldQuatity18: ''
                }
            };
        case UPDATE_SIZE_RATIO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeRatioform: {
                    fldQuatity01: '',
                    fldQuatity02: '',
                    fldQuatity03: '',
                    fldQuatity04: '',
                    fldQuatity05: '',
                    fldQuatity06: '',
                    fldQuatity07: '',
                    fldQuatity08: '',
                    fldQuatity09: '',
                    fldQuatity10: '',
                    fldQuatity11: '',
                    fldQuatity12: '',
                    fldQuatity13: '',
                    fldQuatity14: '',
                    fldQuatity15: '',
                    fldQuatity16: '',
                    fldQuatity17: '',
                    fldQuatity18: ''
                }
            };
        case FETCH_SINGLE_SIZE_RATIO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeRatioform: updatePayload
            };
        case DELETE_SIZE_RATIO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeRatioform: {}
            };
        case RESET_SIZE_RATIO_INFO:
            return {
                ...state,
                sizeRatioform: {
                    fldQuatity01: '',
                    fldQuatity02: '',
                    fldQuatity03: '',
                    fldQuatity04: '',
                    fldQuatity05: '',
                    fldQuatity06: '',
                    fldQuatity07: '',
                    fldQuatity08: '',
                    fldQuatity09: '',
                    fldQuatity10: '',
                    fldQuatity11: '',
                    fldQuatity12: '',
                    fldQuatity13: '',
                    fldQuatity14: '',
                    fldQuatity15: '',
                    fldQuatity16: '',
                    fldQuatity17: '',
                    fldQuatity18: ''
                }
            };
        case CREATE_SIZE_RATIO_FORM:
        case UPDATE_SIZE_RATIO_FORM:
            return {
                ...state,
                loading: false,
                sizeRatioform: {
                    ...state.sizeRatioform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_SIZE_RATIO_FAILURE:
        case CREATE_SIZE_RATIO_FAILURE:
        case UPDATE_SIZE_RATIO_FAILURE:
        case FETCH_SINGLE_SIZE_RATIO_FAILURE:
        case DELETE_SIZE_RATIO_FAILURE:
            return {
                ...state,
                loading: false
            };
        case RESET_SIZE_RATIO_DATA:
            return {
                ...state,
                loading: false,
                sizeRatio: []
            };
        default:
            return state;
    }
};
